<div class="bv-sidebar__header">
  @if (header_logo) {
    <a routerLink="/companies/list" class="bv-sidebar__logo">
      <img [attr.src]="header_logo" alt="Logo" />
    </a>
  }
  @if (header_name) {
    <span class="bv-sidebar__firm-name">{{ header_name }}</span>
  }
  <button class="bv-sidebar__toggle" (click)="asideToggle.toggle()">
    <mat-icon>chevron_left</mat-icon>
  </button>
</div>

<nav class="bv-sidebar__nav">
  @if (!isItRole && !isLogsRole) {
    <div class="bv-sidebar__section">
      <span class="bv-sidebar__section-label">{{ 'MENU.SECTION_PRINCIPAL' | translate }}</span>

      <a class="bv-sidebar__item" routerLink="/companies/list" routerLinkActive="bv-sidebar__item--active"
        (click)="onClickMenu('Sociedades')">
        <mat-icon>business</mat-icon>
        <span class="bv-sidebar__label">{{ 'MENU.COMPANIES' | translate }}</span>
      </a>

      <a class="bv-sidebar__item" routerLink="/individuals" routerLinkActive="bv-sidebar__item--active"
        (click)="onClickMenu('Personas')">
        <mat-icon>people</mat-icon>
        <span class="bv-sidebar__label">{{ 'MENU.PERSONS' | translate }}</span>
      </a>

      @if (!isGroup) {
        <a class="bv-sidebar__item" routerLink="/map" routerLinkActive="bv-sidebar__item--active"
          (click)="onClickMenu('mapaSocietario')">
          <mat-icon>account_tree</mat-icon>
          <span class="bv-sidebar__label">{{ 'MENU.CORPOTATE_MAP' | translate }}</span>
        </a>
      }

      <a class="bv-sidebar__item" routerLink="/library" routerLinkActive="bv-sidebar__item--active"
        (click)="onClickMenu('Biblioteca')">
        <mat-icon>folder_open</mat-icon>
        <span class="bv-sidebar__label">{{ 'MENU.LIBRARY' | translate }}</span>
      </a>

      @if (canSeeContracts) {
        <a class="bv-sidebar__item" routerLink="/contracts" routerLinkActive="bv-sidebar__item--active"
          (click)="onClickMenu('Contratos')">
          <mat-icon>description</mat-icon>
          <span class="bv-sidebar__label">{{ 'MENU.CONTRACTS' | translate }}</span>
        </a>
      }
    </div>

    <div class="bv-sidebar__section">
      <span class="bv-sidebar__section-label">{{ 'MENU.SECTION_MANAGEMENT' | translate }}</span>

      <a class="bv-sidebar__item" routerLink="/alerts" routerLinkActive="bv-sidebar__item--active"
        (click)="onClickMenu('Alertas y Vencimientos')">
        <mat-icon>notifications</mat-icon>
        <span class="bv-sidebar__label">{{ 'MENU.EXPIRATIONS' | translate }}</span>
      </a>

      @if (isGroupFirm && canSeeAdministration) {
        <a class="bv-sidebar__item" routerLink="/administration/list" routerLinkActive="bv-sidebar__item--active"
          (click)="onClickMenu('Administración')">
          <mat-icon>app_registration</mat-icon>
          <span class="bv-sidebar__label">{{ 'MENU.ADMINISTRATION' | translate }}</span>
        </a>
      }

      <a class="bv-sidebar__item" routerLink="/information" routerLinkActive="bv-sidebar__item--active"
        (click)="onClickMenu('information')">
        <mat-icon>share</mat-icon>
        <span class="bv-sidebar__label">{{ 'MENU.SHAREINFO' | translate }}</span>
      </a>
    </div>
  }

  @if (isItRole) {
    <div class="bv-sidebar__section">
      <span class="bv-sidebar__section-label">{{ 'MENU.SECTION_SECURITY' | translate }}</span>

      <a class="bv-sidebar__item" routerLink="/users" routerLinkActive="bv-sidebar__item--active"
        (click)="onClickMenu('Usuarios')">
        <mat-icon>manage_accounts</mat-icon>
        <span class="bv-sidebar__label">{{ 'MENU.USERS' | translate }}</span>
      </a>

      <a class="bv-sidebar__item" routerLink="/administration/list" routerLinkActive="bv-sidebar__item--active"
        (click)="onClickMenu('Administración')">
        <mat-icon>app_registration</mat-icon>
        <span class="bv-sidebar__label">{{ 'MENU.ADMINISTRATION' | translate }}</span>
      </a>

      <a class="bv-sidebar__item" routerLink="/logs" routerLinkActive="bv-sidebar__item--active"
        (click)="onClickMenu('Logs')">
        <mat-icon>history</mat-icon>
        <span class="bv-sidebar__label">{{ 'MENU.LOGS' | translate }}</span>
      </a>
    </div>
  }

  @if (isLogsRole) {
    <div class="bv-sidebar__section">
      <span class="bv-sidebar__section-label">{{ 'MENU.SECTION_LOGS' | translate }}</span>

      <a class="bv-sidebar__item" routerLink="/logs" routerLinkActive="bv-sidebar__item--active"
        (click)="onClickMenu('Logs')">
        <mat-icon>history</mat-icon>
        <span class="bv-sidebar__label">{{ 'MENU.LOGS' | translate }}</span>
      </a>
    </div>
  }
</nav>

@if (!isItRole && !isLogsRole) {
  <div class="bv-sidebar__cta">
    <a class="bv-sidebar__cta-btn" routerLink="/create/company" (click)="onClickMenu('Creación sociedad')">
      <mat-icon>add</mat-icon>
      <span class="bv-sidebar__label">{{ 'MENU.ADD' | translate }}</span>
    </a>
  </div>
}

<div class="bv-sidebar__footer">
  <img [attr.src]="brevity_logo" alt="Brevity" />
  <span class="bv-sidebar__copyright">&copy; {{ currentYear }} Brevity</span>
</div>
